import React, { useEffect, useState } from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const getImage = (filename) => `/assets/images/${filename}.png`;

const LottieOrImageView = ({ filename, width = 30, height = 30, style = {} }) => {
  const [showLottie, setShowLottie] = useState(null); // null = checking

  const lottieUrl = `${process.env.PUBLIC_URL}/animations/${filename}.lottie`;
  const image = getImage(filename);

  useEffect(() => {
    const checkLottie = async () => {
      try {
        const res = await fetch(lottieUrl);
        const text = await res.clone().text();

        const isFakeLottie =
          res.url.includes("/index.html") || 
          text.startsWith("<!DOCTYPE html") || 
          text.includes("<html");

        const isLottie = res.ok && !isFakeLottie;

        setShowLottie(isLottie);
      } catch {
        setShowLottie(false);
      }
    };
  
    setShowLottie(null);
    checkLottie();
  }, [lottieUrl]);

if (showLottie === null) return null; // or a loader

if (showLottie) {
    return (
      <DotLottieReact
        src={lottieUrl}
        autoplay
        loop
        style={{ width, height, ...style }}
      />
    );
  }
 
  return (
    <img
      src={image}
      alt={filename}
      width={width}
      height={height}
      style={{
        objectFit: 'contain',
        borderRadius: 4,
        width,
        height,
        ...style,
      }}
    />
  );
};

export default LottieOrImageView;